const md5 = require('md5')
/** js工具 */
const getType = function (data) {
  return Object.prototype.toString.call(data).match(/\s(\w+)/)[1];
};

// 将formdata中的数据转为对象
const expandFormData = function (form) {
  const data = {};
  for (const [k, v] of form.entries()) {
    if (!["File", "Undefined"].includes(getType(v))) {
      data[k] = v;
    }
  }
  return data;
};

function getFileMd5 (file) {
  const reader = new FileReader()
  reader.readAsArrayBuffer(file)
  return new Promise((resolve, reject) => {
    try {
      reader.onloadend = function (evt) {
        const result = evt.target.result
        const viewer = new DataView(result)
        let arr = []
        for (let i = 0; i < viewer.byteLength; i++) {
          arr.push(viewer.getUint8(i))
        }
        resolve(md5(arr))
      }
    } catch (err) {
      reject(err)
    }
  })
}


export {
    getType,
    expandFormData,
    getFileMd5
}